module.exports = __webpack_public_path__ + "img/d1.231a1fc1.jpg";